import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { first, map } from 'rxjs';

import { AuthService } from './auth.service';

export function createAuthCanActivate(redirectTo: string): CanActivateFn {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const router = inject(Router);
    const auth = inject(AuthService);

    // Check for coordinator_token in query params at any level of the route tree
    let coordinatorToken: string | null = null;
    let currentRoute: ActivatedRouteSnapshot | null = route;

    // Traverse up the route tree to find coordinator_token
    while (currentRoute && !coordinatorToken) {
      coordinatorToken = currentRoute.queryParamMap.get('coordinator_token');
      currentRoute = currentRoute.parent;
    }

    if (coordinatorToken) {
      // Set the coordinator token for authentication
      auth.setToken(coordinatorToken);

      // Remove the token from URL for security
      const urlTree = router.parseUrl(state.url);
      const { coordinator_token, ...otherParams } = urlTree.queryParams;
      urlTree.queryParams = otherParams;

      router.navigateByUrl(urlTree, { replaceUrl: true });
      return true;
    }

    return auth.authenticated.pipe(
      first(),
      map((isAuth) => {
        if (!isAuth) {
          auth.logout('guard');
          return router.parseUrl(redirectTo);
        }
        return isAuth;
      }),
    );
  };
}
